import { PropsWithChildren } from 'react';
import styled from 'styled-components/macro';
import { Sidebar, SidebarDetails } from '../sidebar/Sidebar';
import { spacing02 } from '../../../styling/spacing';

type Props = PropsWithChildren<{
  sidebarDetails: SidebarDetails;
}>;

export const PDF_PAGE_HEIGHT = 1525;

export const PdfPage = ({ children, sidebarDetails }: Props) => {
  return (
    <Page>
      <Content>{children}</Content>
      <StyledSidebar {...sidebarDetails} />
    </Page>
  );
};

const Page = styled.div`
  display: flex;
  page-break-after: always;

  border: solid black;
  border-width: 1px 2px 1px 1px;

  &:last-of-type {
    page-break-after: avoid;
  }
`;

const Content = styled.div`
  display: flex;
  flex: 1;
  padding: ${spacing02};
`;

const StyledSidebar = styled(Sidebar)`
  width: 370px;
  height: ${PDF_PAGE_HEIGHT}px;
`;
